module.exports = __webpack_public_path__ + "img/audio-4.2be25dc0.jpg";